import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { ITemplateEmailNotificationCompanyApi } from "./base/templateEmailNotificationCompanyApi";
import {
	GetEmailTemplateRequest,
	SearchgridTemplateRequest,
} from "../models/request/templateEmailNotificationCompanyRequest";
import { PaginationResponse } from "../models/common/paginationResponse";
import {
	GetEmailTemplateResponse,
	SearchgridTemplateResponse,
} from "../models/response/templateEmailNotificationCompanyResponse";

const baseRoute: string = "TemplateEmailNotificationCompany";

export class TemplateEmailNotificationCompanyApi extends ITemplateEmailNotificationCompanyApi {
	getEmailTemplate(request: GetEmailTemplateRequest): Promise<AxiosResponse<Result<Array<GetEmailTemplateResponse>>>> {
		return api.get(`${baseRoute}/GetEmailTemplate`, { params: request });
	}

	getSearchGridTemplate(
		request: SearchgridTemplateRequest,
	): Promise<AxiosResponse<PaginationResponse<SearchgridTemplateResponse>>> {
		return api.get(`${baseRoute}/SearchgridTemplate`, { params: request });
	}

	getEmailTemplateFormated(
		request: GetEmailTemplateRequest,
	): Promise<AxiosResponse<Result<Array<GetEmailTemplateResponse>>>> {
		return api.get(`${baseRoute}/GetEmailTemplateFormated`, {
			params: request,
		});
	}
}
